import React, { useContext, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box, Drawer, useMediaQuery } from '@mui/material';
import { jwtDecode } from 'jwt-decode';
import { AuthContext } from '../components/signin/AuthContext';
import { v3Theme } from './theme';
import Sidebar from './components/Sidebar';
import TopBar  from './components/TopBar';

function tokenValid(token) {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() / 1000 < exp;
  } catch { return false; }
}

export default function V3Layout() {
  const { token, setToken } = useContext(AuthContext);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isDesktop = useMediaQuery(v3Theme.breakpoints.up('md'));

  if (!token || !tokenValid(token)) {
    localStorage.setItem('authenticated', 'false');
    localStorage.setItem('JWT', '');
    setToken(null);
    return <Navigate to="/" replace />;
  }

  return (
    <ThemeProvider theme={v3Theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden', background: '#060d07' }}>

          {/* Desktop sidebar — always visible */}
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <Sidebar />
          </Box>

          {/* Mobile sidebar — drawer */}
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            ModalProps={{ keepMounted: true }}
            PaperProps={{ sx: { background: 'transparent', border: 'none' } }}
            sx={{ display: { xs: 'block', md: 'none' } }}
          >
            <Sidebar />
          </Drawer>

          {/* Main area */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              minWidth: 0,
            }}
          >
            <TopBar onMenuClick={() => setMobileOpen(o => !o)} />

            {/* Scrollable content */}
            <Box
              sx={{
                flex: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                px: { xs: 2, sm: 3, md: 4 },
                py: 3,
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(118,196,66,0.2) transparent',
                '&::-webkit-scrollbar': { width: 6 },
                '&::-webkit-scrollbar-track': { background: 'transparent' },
                '&::-webkit-scrollbar-thumb': { background: 'rgba(118,196,66,0.2)', borderRadius: 3 },
              }}
            >
              <Outlet />
            </Box>
          </Box>
      </Box>
    </ThemeProvider>
  );
}
